import styled from 'styled-components';

import {
  color,
  layout,
  typography,
  mobile,
  smallDesktop,
  tablet,
  paddingLeftSmallDesktop,
} from '../../GlobalStyles';

const { size0, size4, size5, size6, size7, size8, breakpoint2 } = layout;
const { size7: font_size7, lineHeight7, lineHeight5, lineHeight4 } = typography;
const { white, black, gray1, royalBlue1, royalBlue5 } = color;

interface ContainerProps {
  backgroundColor: string;
}

export const Container = styled.div`
  background-color: ${gray1};
`;

export const CardContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${size5}px;
  min-width: 380px;
  max-width: 400px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 36px ${size4}px;

  ${mobile} {
    min-width: 304px;
    max-width: 304px;
    max-height: 424px;
    padding: ${size6}px ${size5}px;
  }

  ul {
    list-style: outside;
    margin-left: ${size7}px;
  }
`;

export const CardIcon = styled.div`
  font-size: ${font_size7};

  svg {
    color: ${black};
  }
`;

export const CardTitle = styled.div`
  color: ${black};
  height: calc(${lineHeight7}*3);

  ${tablet} {
    height: calc(${lineHeight5}*3);
  }

  ${mobile} {
    height: calc(${lineHeight4}*3);
  }
`;

export const CardText = styled.div`
  color: ${black};
  white-space: pre-line;
`;

export const TitleContainer = styled.div`
  background-color: ${white};
  border-top: 1px solid ${black};
  padding: 36px ${paddingLeftSmallDesktop};
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mobile} {
    padding: ${size8}px ${size6}px;
  }
`;

export const Title = styled.h2`
  color: ${black};
`;

export const ChevronWrapper = styled.div`
  display: flex;
  align-items: center;

  @media only screen and (min-width: 1300px) {
    display: none;
  }
`;

export const ChevronLeft = styled.div`
  cursor: pointer;
`;

export const ChevronRight = styled.div`
  cursor: pointer;
`;

export const CardsWrapper = styled.div`
  display: flex;
  overflow: scroll;
  border-bottom: 1px solid ${black};

  /* Hide scrollbar for WebKit browsers */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge, and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const LeftFiller = styled.div`
  width: calc((100% - 1220px) / 2);
  min-width: 72px;
  background-color: ${royalBlue1};

  ${smallDesktop} {
    min-width: 40px;
  }
  @media only screen and (max-width: ${breakpoint2}px) {
    min-width: ${size0}px;
  }
`;

export const RightFiller = styled.div`
  width: calc((100% - 1220px) / 2);
  min-width: 40px;
  background-color: ${royalBlue5};

  @media only screen and (max-width: ${breakpoint2}px) {
    min-width: ${size0}px;
  }
`;
